import * as React from "react";
import { useEffect, useMemo, useRef } from "react";
import { useDaoContext } from "../diseaseview/DaoContext";
import { featureToLines } from "fe-common/logic";
import { v4 as uuid } from "uuid";
import { GenderValue, KahunCategories } from "shared";
import { QualifiedFeatureFragment } from "fe-common/graphql";
//endregion [[ Functions
// ]]

export interface FeatureWithName {
  name: string;
  value: QualifiedFeatureFragment;
}
// TODO:
export interface useFeatureSuggestionsProps {
  term: string;
  categories: KahunCategories[];
  gender?: GenderValue | null;
}
export interface useFeatureSuggestionsAPI {
  loading: boolean;
  results: FeatureWithName[];
}

export function useFeatureSuggestions(
  term: string,
  categories: KahunCategories[],
  gender?: GenderValue | null,
  patientFacing?: boolean,
  panelIds?: string[],
  ancestorsIds?: string[],
): useFeatureSuggestionsAPI {
  const [loading, setLoading] = React.useState<boolean>(false);

  const [results, setResults] = React.useState<FeatureWithName[]>([]);

  const dao = useDaoContext();

  let currentSessionId = useRef<string>();

  useEffect(() => {
    let active = true;
    if (!term || term.trim() === "") {
      // there is a server bug with single char search
      setResults([]);
    } else {
      setLoading(true);
      currentSessionId.current = uuid();
      let sessionId = currentSessionId.current;
      try {
        dao
          .searchQualifiedFeatures(
            term,
            categories,
            gender,
            patientFacing,
            panelIds,
            ancestorsIds,
          )
          .then((qfs) => {
            if (currentSessionId.current === sessionId) {
              if (active && qfs) {
                setResults(
                  qfs.map((qf) => ({
                    name: featureToLines(qf, false, [], [], patientFacing)[0],
                    value: qf,
                  })),
                );
              } else {
                setResults([]);
              }
              setLoading(false);
            }
          });
      } catch (e) {
        console.error(e);
        setResults([]);
        setLoading(false);
      }
    }

    return undefined;
  }, [dao, term, categories, gender]);

  return useMemo(() => ({ loading, results }), [loading, term]);
}
